'use client';

import { historyStackAtom } from '@/atom/historyStack';
import { SurveyCGType } from '@/types/graphql/root';
import Back2424 from '@svg/common/back_24_24.svg';
import Home2424 from '@svg/main/sideMenu/home_24_24.svg';
import { useSetAtom } from 'jotai';
import Link from 'next/link';
import { useParams, useRouter } from 'next/navigation';
import { useMemo } from 'react';

export default function TripTopBar({
  title,
  isEmbedded,
  trip,
  onClickHome,
}: {
  title: string;
  isEmbedded: boolean;
  trip: SurveyCGType | null;
  onClickHome: () => void;
}) {
  const router = useRouter();
  const { id: tripId } = useParams<{ id: string }>();

  const setHistoryStack = useSetAtom(historyStackAtom);

  const hasNotePermission = useMemo(() => {
    if (isEmbedded) return false;
    if (trip?.isOwn) return true;
    if (trip?.isCoEdit) return true;
    return false;
  }, [isEmbedded, trip?.isOwn, trip?.isCoEdit]);

  return (
    <>
      <div className='fixed top-0 flex flex-row items-center max-w-480pxr w-full p-16pxr h-56pxr bg-white border-b border-gray-200 z-10 gap-8pxr justify-between'>
        <div className='flex items-center gap-8pxr'>
          <button onClick={() => router.back()}>
            <Back2424 className='flex-none' />
          </button>
          <h4
            className='cursor-pointer text-custom-black heading-18-b line-clamp-1'
            onClick={() => {
              if (!hasNotePermission) return;
              setHistoryStack((prev) => {
                if (prev.length > 0) {
                  return [...prev, {}];
                }
                return prev;
              });
              router.push(`/trip/note/${tripId}`, { scroll: false });
            }}
          >
            {title}
          </h4>
        </div>
        {!isEmbedded && (
          <button onClick={onClickHome} className='flex-none w-24pxr h-24pxr'>
            <Home2424 />
          </button>
        )}
      </div>
      <div className='h-56pxr'></div>
    </>
  );
}
